import axios from './../../config/axios'

function index() {
    return axios().get('auth/roles')
}
function list(payload) {
    return axios().get('auth/roles-list', { params: payload })
}
function get(id) {
    return axios().get(`auth/roles/${id}`)
}
function create(data) {
    return axios().post(`auth/roles`, data)
}
function update(data) {
    return axios().put(`auth/roles/${data.id}`, data)
}
function remove(id){
    return axios().delete(`auth/roles/${id}`)
}
function users(id){
    return axios().get(`auth/roles/${id}/users`)
}

export default {
    index,
    get,
    list,
    create,
    update,
    remove,
    users
}